var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import classNames from 'classnames';
import { useRef } from 'react';
import OverlayTrigger from 'react-bootstrap/lib/OverlayTrigger';
import Popover from 'react-bootstrap/lib/Popover';
import { useIntl } from 'react-intl';
import ItemsFilter from './filters/ItemsFilter';
import NumberFilter from './filters/NumberFilter';
import SearchFilter from './filters/SearchFilter';
import SelectFilter from './filters/SelectFilter';
import UserFilter from './filters/UserFilter';
var ColumnHeader = function (_a) {
    var filter = _a.filter, sortKey = _a.sortKey, onSort = _a.onSort, onFilter = _a.onFilter, _b = _a.searchParams, searchParams = _b === void 0 ? {} : _b, className = _a.className, title = _a.title, id = _a.id, _c = _a.visible, visible = _c === void 0 ? true : _c, style = _a.style, _d = _a.badge, badge = _d === void 0 ? undefined : _d;
    var intl = useIntl();
    var target = useRef(null);
    if (!visible)
        return null;
    var isSearchFiltered = filter && searchParams.search && searchParams.search[filter.key] !== undefined;
    var isSelectFiltered = filter && searchParams.select && searchParams.select[filter.key] !== undefined;
    var isItemsFiltered = filter &&
        searchParams.filter &&
        searchParams.filter[filter.key] &&
        searchParams.filter[filter.key].items &&
        searchParams.filter[filter.key].items.length > 0;
    var isNumberFiltered = filter &&
        searchParams.filter &&
        searchParams.filter[filter.key] &&
        (searchParams.filter[filter.key].lesser != null ||
            searchParams.filter[filter.key].greater != null);
    var sortClassName = classNames('fa margin10R', {
        clickable: sortKey,
        'fa-caret-down': sortKey && searchParams.desc,
        'fa-caret-up': sortKey && !searchParams.desc,
    });
    var getFilter = function (filterParam) {
        if (filterParam.type === 'search') {
            return (_jsx(SearchFilter, { initialValue: searchParams.search && searchParams.search[filterParam.key], onFilter: function (filterItems) { return onFilter(filterItems); }, isFiltered: isSearchFiltered, intl: intl }));
        }
        if (filterParam.type === 'items') {
            return (_jsx(ItemsFilter, { items: filterParam.items, renderItem: filterParam.renderItem, initialFilteredItems: searchParams.filter &&
                    searchParams.filter[filterParam.key] &&
                    searchParams.filter[filterParam.key].items, onFilter: function (filterItems) { return onFilter(filterItems); }, isFiltered: isItemsFiltered, intl: intl }));
        }
        if (filterParam.type === 'select') {
            return (_jsx(SelectFilter, { initialValue: searchParams.select && searchParams.select[filterParam.key], onFilter: function (filterItems) { return onFilter(filterItems); }, loadFunc: filterParam.loadFunc, isFiltered: isSelectFiltered, intl: intl }));
        }
        if (filterParam.type === 'user') {
            return (_jsx(UserFilter, { initialValue: searchParams.filter &&
                    searchParams.filter[filterParam.key] &&
                    searchParams.filter[filterParam.key].items &&
                    searchParams.filter[filterParam.key].items[0], onFilter: function (filterItems) { return onFilter(filterItems); }, isFiltered: isItemsFiltered, intl: intl }));
        }
        if (filterParam.type === 'number') {
            return (_jsx(NumberFilter, { initialValue: searchParams.filter && searchParams.filter[filterParam.key], onFilter: function (filterItems) { return onFilter(filterItems); }, isFiltered: isNumberFiltered, intl: intl }));
        }
    };
    return (_jsxs("th", __assign({ className: classNames(className, 'sticky-header'), id: id, style: style, ref: target }, { children: [_jsxs("span", __assign({ className: classNames({ clickable: onSort }), onClick: function () { return onSort && onSort(sortKey); } }, { children: [!!sortKey && sortKey === searchParams.sortKey && _jsx("i", { className: sortClassName }), title] })), badge && _jsx("br", {}), badge, filter && (_jsx(OverlayTrigger, __assign({ trigger: "click", rootClose: true, placement: "bottom", overlay: _jsx(Popover, __assign({ id: "filterPopover" }, { children: getFilter(filter) })), container: target.current }, { children: _jsx("i", { className: classNames('fa fa-filter margin10L clickable filter-icon', {
                        red: isItemsFiltered || isSearchFiltered || isSelectFiltered || isNumberFiltered,
                    }) }) })))] })));
};
export default ColumnHeader;
